<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="doNew()">
              New Proposal Plan
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="procId"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td>{{ row.item.propType }}</td>
                  <td>{{ row.item.polType }}</td>
                  <td>{{ row.item.scheme }}</td>
                  <td>{{ row.item.planNo }}</td>
                  <td>{{ row.item.planDesc }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      review
                      @review="doReview(row.item)"
                      remove
                      @remove="doPromptRemove(row.item)"
                      query
                      @query="doQuery(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        <p>Are you sure you want to delete the selected Proposal Plan?</p>
        <div class="queryValue">
          PropType: {{ selectedProp.propType }}<br />
          PolType: {{ selectedProp.polType }}<br />
          Scheme: {{ selectedProp.scheme }}<br />
          PlanNo: {{ selectedProp.planNo }}
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      toggleArray: [false],
      headers: [
        { text: 'Proposal Type', value: 'propType' },
        { text: 'Policy Type', value: 'polType' },
        { text: 'Scheme/Class', value: 'scheme' },
        { text: 'Plan No.', value: 'planNo' },
        { text: 'Plan Description', value: 'planDesc' },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      selectedProp: {
        propType: null,
        polType: null,
        scheme: null,
        planNo: null
      },
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  mounted() {
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getPropPlanList
      if (apiURI) {
        try {
          this.loading = true
          const result = await this.$http.get(apiURI)
          if (result) {
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  propType: datamap.propType,
                  polType: datamap.polType,
                  scheme: datamap.scheme,
                  planNo: datamap.planNo,
                  planDesc: datamap.planDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doReview(obj) {
      this.$router.push({ name: 'propPlanReview', params: { paramMode: 'review', paramObjRes: obj } })
    },
    doNew() {
      this.$router.push({ name: 'propPlanReview', params: { paramMode: 'create' } })
    },
    doQuery(obj) {
      this.$router.push({ name: 'propPlanReview', params: { paramMode: 'query', paramObjRes: obj } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp.propType = data.propType
        this.selectedProp.polType = data.polType
        this.selectedProp.scheme = data.scheme
        this.selectedProp.planNo = data.planNo
      }
    },
    async doRemove() {
      const apiURI = this.menu.deletePropPlan
      if (apiURI) {
        const expand = this.selectedProp
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.propPlanParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
